const availableFeatures = {
  camera: {
    title: 'Camera',
    description: 'Show the camera to employees when they are clocking in or out.  Disabling this' +
    ' will stop photos being taken.',
    value: true,
    preChange() {}, // no-op
    postChange() {}, // no-op
    predicate: () => true,
  },
  shiftcard: {
    title: 'Shift Card',
    description: 'The shift card shows employees their upcoming shift when clocking in, or their' +
    ' next shift when clocking out.  Disabling this will stop the card being shown.',
    value: true,
    preChange() {}, // no-op
    postChange() {}, // no-op
    predicate: () => true,
  },
  leave: {
    title: 'Leave',
    description: 'Allow employees to request leave from this timeclock.',
    value: false,
    preChange() {}, // no-op
    postChange() {},
    predicate(state) {
      // only show this if it's enabled on the server
      return state.getIn(['settings', 'organisation', 'enable_employee_leave']);
    },
  },
  unavailability: {
    title: 'Unavailability',
    description: 'Allow employees to enter unavailability on this timeclock.',
    value: false,
    preChange() {}, // no-op
    postChange() {},
    predicate(state) {
      // only show this if it's enabled on the server
      return state.getIn(['settings', 'organisation', 'enable_availability']);
    },
  },
};

export function getAvailableFeatures() {
  const features = {};
  Object.keys(availableFeatures).forEach((key) => {
    const { title, description, value } = availableFeatures[key];
    features[key] = {
      title,
      description,
      value,
    };
  });

  return features;
}

export function shouldDisplay(state, key) {
  return availableFeatures[key].predicate(state);
}

export function getValue(state, key) {
  // should test against the predicate, too.
  return availableFeatures[key].predicate(state) && state.getIn([key, 'value']);
}

export function preChange(state, key, value) {
  return availableFeatures[key].preChange(state, value);
}

export function postChange(state, key, value) {
  return availableFeatures[key].postChange(state, value);
}

export function checkPredicate(state, key) {
  return availableFeatures[key].predicate(state);
}

export function updateFeaturesBasedOnPredicate(state) {
  // get the predicate for each feature
  return Object.keys(availableFeatures).reduce((features, name) => {
    const feature = availableFeatures[name];
    const currentValue = state.getIn(['settings', 'features', name, 'value']);
    const predicate = feature.predicate(state);
    return {
      ...features,
      [name]: {
        title: feature.title,
        description: feature.description,
        value: predicate && currentValue,
        shouldDisplay: predicate,
      },
    };
  }, {});
  // set the shouldDisplay option to = the predicate
  // set the value option to = predicate && value
}



// WEBPACK FOOTER //
// ./src/store/settings/features/lib.js